<template>
  <Cfg :showMenuCfg="HasShowMenuCfg">
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert"/>
        <Forms ref="frmGroup"
          :title="this.$lang.AutoModel.TitleForm"
          :showHelp="true"
          :showClearButton="true"
          :showSaveButton="true"
          v-on:Clear="onClear"
          v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-6">
              <label for="cbxAutoType"><small class="text-danger">*</small> {{$lang.AutoModel.Autotype}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.autoTypeID.value"
                              :options="form.autoTypeID.options"
                              :state="form.autoTypeID.state"
                              class="mb-3"
                              name="cbxAutoType"
                              @change="onChangeType">
                   <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-6">
              <label for="cbxBrand"><small class="text-danger">*</small> {{$lang.AutoModel.LabelBrand}}:</label>
              <div class="input-group">
                <b-form-select v-model="form.brandID.value"
                                  :options="form.brandID.options"
                                  :state="form.brandID.state"
                                  class="mb-3"
                                  name="cbxBrand">
                    <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtAutoModelName"><small class="text-danger">*</small> {{$lang.AutoModel.LabelName}}:</label>
              <div class="input-group">
                <b-form-input type="text"
                              name="txtAutoModelName"
                              :placeholder="$lang.AutoModel.PlaceholderEnterName"
                              v-model="form.name.value"
                              :size="form.name.maxlength"
                              :required="form.name.required"
                              :state="form.name.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription"> {{$lang.AutoModel.LabelDescription}}:</label>
              <b-form-textarea id="txtDescription"
                          name="txtDescription"
                          v-model.trim="form.description.value"
                          :placeholder="$lang.AutoModel.PlaceholderEnterDescription"
                          :rows="form.description.rows"
                          :size="form.description.maxlength"
                          :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i> <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid"
            :columns="[$lang.AutoModel.DataTable.Type,
                       $lang.AutoModel.DataTable.Brand,
                       $lang.AutoModel.DataTable.Name,
                       $lang.Common.DataTable.Status,
                       $lang.Common.DataTable.ActionDate,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.brand.autoType.name" classCss="text-left" />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.brand.name"  />
            <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name"  />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsActionsButtons="true" :HasDelete="false" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)"  :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import AutoModel from './automodel.js'

export default AutoModel
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/automodel/automodel.vue